/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$Q as $Q,
  rec_AnaliticaTransporte as AnaliticaTransporte,
  rec_Bo as Bo,
  rec_Componente__Dolar_95_36 as Componente__Dolar_95_36,
  rec_Componente_vDolar_118_36 as Componente_vDolar_118_36,
  rec_EstadoError as EstadoError,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ResumenCostos as ResumenCostos,
  rec_Rr as Rr,
  rec_SelectorFecha as SelectorFecha,
  rec_api as api,
  rec_e$ as e$,
  rec_kQ as kQ,
  rec_t$ as t$,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function ReportesTransporte() {
  let e = Go(),
    [t, n] = (0, React.useState)(`gastos`),
    [r, i] = (0, React.useState)(e$),
    [a, o] = (0, React.useState)(kQ),
    [s, c] = (0, React.useState)(null),
    [l, u] = (0, React.useState)(!0),
    [f, p] = (0, React.useState)(``),
    m = (0, React.useCallback)(async () => {
      u(!0);
      try {
        (c(await api(`/transporte/reporte?desde=${r}&hasta=${a}`)), p(``));
      } catch (e) {
        p(e.message);
      } finally {
        u(!1);
      }
    }, [r, a]);
  return (
    (0, React.useEffect)(() => {
      m();
    }, [m]),
    (
      <div
        className={`flex flex-col gap-4`}
        children={[
          <EstadoError mensaje={f} onReintentar={m} />,
          <section
            className={`${Bo} flex flex-wrap items-end gap-3`}
            children={[
              <label
                className={`flex flex-col gap-1 text-sm text-(--text)`}
                children={[
                  `Desde`,
                  <SelectorFecha value={r} onChange={i} max={a} />,
                ]}
              />,
              <label
                className={`flex flex-col gap-1 text-sm text-(--text)`}
                children={[
                  `Hasta`,
                  <SelectorFecha value={a} onChange={o} min={r} />,
                ]}
              />,
              <div
                className={`flex gap-1 rounded-xl border border-(--border) p-1`}
                children={$Q.map((e) => (
                  <button
                    key={e.id}
                    type={`button`}
                    onClick={() => n(e.id)}
                    className={`rounded-lg px-3 py-1.5 text-sm transition ${t === e.id ? `bg-(--accent) text-(--accent-fg)` : `text-(--text) hover:text-(--text-h)`}`}
                    children={e.label}
                  />
                ))}
              />,
              <button
                type={`button`}
                onClick={() =>
                  t$(s, {
                    desde: r,
                    hasta: a,
                    avisos: e,
                  })
                }
                disabled={!s || s.ordenes === 0}
                className={`${zo} ml-auto`}
                children={[
                  <Rr className={`mr-1 inline h-3.5 w-3.5`} />,
                  ` Llevar a Excel`,
                ]}
              />,
            ]}
          />,
          l ? (
            <Componente__Dolar_95_36 />
          ) : f ? null : s.ordenes === 0 ? (
            <Componente_vDolar_118_36
              texto={`No hubo órdenes en esas fechas. Probá con un período más largo.`}
            />
          ) : t === `gastos` ? (
            <ResumenCostos datos={s} />
          ) : (
            <AnaliticaTransporte datos={s} />
          ),
        ]}
      />
    )
  );
}
